import React, {useEffect, useRef, useState} from "react";
import ThemeData from "../../../Interfaces/ThemeData";
import ThemesListItem from "./ThemesListItem";
import Isotope from "isotope-layout";
import {ErrorBoundary} from "../../Common/ErrorBoundary";

interface ThemesListProps {
    themes: ThemeData[],
    currentTheme?: ThemeData,
    currentTab: string,
    onClickAction: (data: ThemeData) => void,
    onSelectThemeAction: (data: ThemeData) => void
}

const ThemesList: React.FC<ThemesListProps> = ({themes, currentTheme, currentTab, onClickAction, onSelectThemeAction}) => {

    const [isotope, setIsotope] = useState<Isotope>();
    const isotopeRef = useRef<HTMLDivElement>(null);

    const onImageLoaded = (data: ThemeData) => {
        if (isotope) {
            isotope.layout();
        }
    }

    useEffect(() => {
        if (isotope) {
            isotope.layout();
        }
    }, [currentTab])

    useEffect(() => {
        if (!isotope) {
            if (isotopeRef.current) {
                const isotope2 = new Isotope(isotopeRef.current, {
                    itemSelector: '.grid-item',
                    layoutMode: 'masonry',
                    transitionDuration: '0.45s',
                    resize: true,
                    filter: '*',
                    stagger: 0,
                    percentPosition: true,
                    masonry: {
                        columnWidth: '.grid-sizer'
                    }
                })
                setIsotope(isotope2)
            }
        } else {
            isotope.reloadItems();
            isotope.layout();
        }
    }, [themes]);

    return (
        <div className="themes-container">
            <div className="themes-grid">
                {
                    themes.map(
                        (theme, index) =>
                        <ErrorBoundary
                            place={'Theme-ThemeListItem'}
                            key={'theme-list-item-error-boundary-' + theme.themeId}>
                            <ThemesListItem
                                data={theme}
                                index={index}
                                key={'theme-list-item-' + theme.themeId}
                                onClickAction={onClickAction}
                                onSelectThemeAction={onSelectThemeAction}
                                onImageLoaded={onImageLoaded}
                            />
                        </ErrorBoundary>
                    )
                }
            </div>
        </div>
    )
}

export default ThemesList;